import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CommonService } from '../app/common.service';

@Injectable({
  providedIn: 'root'
})
export class ResolverService  implements Resolve<any>{

  constructor(private userService: CommonService) { }
  resolve():Promise<Observable<any>> {
    let breedsId = sessionStorage.getItem('breedsId');
    var getbreedseditApi= "/breeds/"+ breedsId;
    return this.userService.getApi(getbreedseditApi);
    catchError((error) => {
      return of('No data');
   })
  }
}
